module.exports = __webpack_public_path__ + "img/BerndLindemann_140x140_rund.6dad0d79.jpg";